import cn from 'classnames';

import { EParticipantsImportStatus, type IImportError } from '@/api/endpoints/schools/schoolParticipants';

import styles from './ImportErrorsLog.module.scss';

interface IProp {
  errors: IImportError[];
  importStatus: EParticipantsImportStatus;
}

export const ImportErrorsLog = ({ errors, importStatus }: IProp) => {
  const IMPORT_STATUS_TO_COMPONENT_MAPPER = {
    [EParticipantsImportStatus.Completed]: (
      <>
        <p className={cn(styles.title, { [styles['title-success']]: errors.length === 0 })}>
          {errors.length > 0 ? 'Обнаруженные ошибки:' : 'Ошибок не обнаружено'}
        </p>
        {errors.length !== 0 && (
          <ul className={styles['errors-list']}>
            {errors.map(({ row, message }) => (
              <li
                className={styles['errors-item']}
                key={row}
              >
                Строка {row}: {message}
              </li>
            ))}
          </ul>
        )}
      </>
    ),
    [EParticipantsImportStatus.PartiallyCompleted]: (
      <p className={cn(styles.title, styles['title-partially-completed'])}>
        Импорт завершен частично, не все пользователи были зачислены!
      </p>
    ),
    [EParticipantsImportStatus.Pending]: (
      <p className={cn(styles.title, styles['title-processing'])}>Файл находится в обработке, ожидайте</p>
    ),
    [EParticipantsImportStatus.Processing]: (
      <p className={cn(styles.title, styles['title-processing'])}>Файл находится в обработке, ожидайте</p>
    ),
  };

  return (
    <div
      className={cn(
        styles.wrapper,
        { [styles['wrapper-success']]: errors.length === 0 },
        {
          [styles['wrapper-processing']]:
            importStatus === EParticipantsImportStatus.Pending || importStatus === EParticipantsImportStatus.Processing,
        },
        { [styles['wrapper-partially-completed']]: importStatus === EParticipantsImportStatus.PartiallyCompleted },
      )}
    >
      {IMPORT_STATUS_TO_COMPONENT_MAPPER[importStatus]}
    </div>
  );
};
